/* istanbul ignore file */
import React, { useState } from 'react';
import { get, isNil } from 'lodash';
import { injectIntl, IntlShape } from 'react-intl';
import { Typography, Grid, Chip } from '@material-ui/core';
import { translate } from 'containers/services/translate';
import messages from 'containers/common/LegalProceedings/JudgementAdd/Recap/messages';
import {
  STATUS_REJECTED,
  STATUS_VALIDATED,
} from 'containers/LawyerFeeNote/constants';
import { DECISION_DIALOG } from 'containers/common/LegalProceedings/DecisionDropDownSupportDocument/constants';
import DropDownDecisionMenu from 'components/SahamDropDown/DropDownDecisionMenu';
import ValidationDialog from 'containers/common/LegalProceedings/DecisionDropDownSupportDocument/ValidationDialog';
import { COLORS } from 'constants/design';
import {
  renderColor,
  renderChipLabel,
} from 'containers/common/LegalProceedings/JudgementAdd/Recap/utils';
export interface DecisionDropDownSupportDocumentProps {
  intl: IntlShape;
  claimId: number;
  claimNumber: string;
  judiciaryProcessId: any;
  supportDocument: any;
  requestMakeDecisionSupportDocument?: Function;
  isConsultation?: boolean;
  claim: any;
  procedureType: string;
}
const StyledTypography = {
  color: COLORS.LIGHT_GREY,
  fontWeight: 400,
  fontSize: '13px',
};
const StyledChip = {
  color: COLORS.WHITE,
  fontWeight: 700,
};
export const DecisionDropDownSupportDocument: React.FC<DecisionDropDownSupportDocumentProps> = ({
  supportDocument,
  ...props
}): JSX.Element => {
  const [dropDown, setDropDown] = useState<null | HTMLElement>(null);

  const [isDialogOpen, setIsDialogOpen] = useState<any>({
    [DECISION_DIALOG.VALIDATION]: false,
    [DECISION_DIALOG.REFUSAL]: false,
  });

  const handleIsDialogOpen = (dialog: string) => () => {
    setIsDialogOpen({
      ...isDialogOpen,
      [dialog]: !get(isDialogOpen, `${dialog}`, false),
    });
  };

  const dropDownMenuElements = () => {
    return [
      {
        title: translate(messages.validateButton, props),
        action: handleIsDialogOpen(DECISION_DIALOG.VALIDATION),
        disabled: false,
      },
      {
        title: translate(messages.rejectedTitle, props),
        action: handleIsDialogOpen(DECISION_DIALOG.REFUSAL),
        disabled: false,
      },
    ];
  };
  return (
    <React.Fragment>
      {get(supportDocument, 'status') != STATUS_VALIDATED && (
        <DropDownDecisionMenu
          setDropDown={setDropDown}
          dropDown={dropDown}
          label={translate(messages.managerDecision, props)}
          menuElements={dropDownMenuElements()}
        />
      )}
      {!isNil(get(supportDocument, 'status', null)) && (
        <Grid direction="row" container spacing={1}>
          <Grid item xs={3}>
            <Typography style={StyledTypography}>
              {translate(messages.statusTitle, props)}
            </Typography>
          </Grid>
          <Grid item xs={11}>
            <Chip
              style={{
                ...StyledChip,
                backgroundColor: renderColor(get(supportDocument, 'status')),
              }}
              label={renderChipLabel(get(supportDocument, 'status'))}
            />
          </Grid>
        </Grid>
      )}

      <ValidationDialog
        claimNumber={props.claimNumber}
        claimId={props.claimId}
        judiciaryProcessId={props.judiciaryProcessId}
        handleClose={handleIsDialogOpen(DECISION_DIALOG.VALIDATION)}
        supportDocument={supportDocument}
        open={isDialogOpen[DECISION_DIALOG.VALIDATION]}
        status={STATUS_VALIDATED}
        requestMakeDecisionSupportDocument={
          props.requestMakeDecisionSupportDocument
        }
        claim={props.claim}
        procedureType={props.procedureType}
      />
      <ValidationDialog
        claimNumber={props.claimNumber}
        claimId={props.claimId}
        judiciaryProcessId={props.judiciaryProcessId}
        handleClose={handleIsDialogOpen(DECISION_DIALOG.REFUSAL)}
        supportDocument={supportDocument}
        open={isDialogOpen[DECISION_DIALOG.REFUSAL]}
        requestMakeDecisionSupportDocument={
          props.requestMakeDecisionSupportDocument
        }
        status={STATUS_REJECTED}
        claim={props.claim}
        procedureType={props.procedureType}
      />
    </React.Fragment>
  );
};

export default injectIntl(DecisionDropDownSupportDocument);
